import useLanguageTranslate from "../../../hooks/useLanguageTranslate";

const YesNoTabs = ({ value, onChange, error }) => {
  const translate = useLanguageTranslate();

  const tabs = [
    { type: true, label_en: "Yes", label_ar: "نعم" },
    { type: false, label_en: "No", label_ar: "لا" },
  ];

  return (
    <>
      <div
        className={`flex w-full ${error ? 'mb-2' : ''}`}
        role="tablist"
      >
        {tabs.map((tab, index) => {
          const isFirst = index === 0;
          const isLast = index === tabs.length - 1;
          const isSelected = value === tab.type;
          
          return (
            <button
              key={String(tab.type)}
              onClick={() => onChange(tab.type)}
              className={`flex-1 h-[50px] flex items-center justify-center px-[16px] py-[13px] transition-all ${
                isFirst ? 'rounded-tl-[10px] rounded-bl-[10px] rtl:rounded-tl-none rtl:rounded-bl-none rtl:rounded-tr-[10px] rtl:rounded-br-[10px]' : ''
              } ${
                isLast ? 'rounded-tr-[10px] rounded-br-[10px] rtl:rounded-tr-none rtl:rounded-br-none rtl:rounded-tl-[10px] rtl:rounded-bl-[10px]' : ''
              } ${
                !isFirst ? 'ml-[-1px] rtl:ml-0 rtl:mr-[-1px]' : ''
              } ${
                isSelected
                  ? "bg-[#E3F8FF] text-[#00719A] border-2 border-solid border-[#00719A] relative"
                  : "bg-white text-[#252C32] border border-solid border-[#DDE2E4]"
              }`}
              role="tab"
              aria-selected={isSelected}
            >
              <span className="text-center text-base font-normal leading-6 tracking-[-0.16px]">
                {translate(tab.label_en, tab.label_ar)}
              </span>
            </button>
          );
        })}
      </div>
      {error && <p className="field-err text-red-500 text-sm">{error}</p>}
    </>
  );
};

export default YesNoTabs;
